import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography, CircularProgress } from '@material-ui/core'
import { get } from 'lodash'
import { CheckCircleOutline } from '@material-ui/icons'
import { useTheme } from '@material-ui/core/styles'

const size = 16

const LoadStateIndicator = ({
  isLoading = false,
  isSuccess = false,
  isError = false,
  errorText = 'An error has occured...',
}) => {
  const theme = useTheme()
  const color = get(theme, isError ? 'palette.error.main' : 'palette.success.main')
  return (
    <Box
      className="load-state-indicator-comp"
      style={{ color }}
      p={1}
      display="inline-flex"
      alignItems="center"
    >
      {isLoading ? (
        <CircularProgress
          data-testid="loading"
          size={size}
          color="primary"
          role="status"
          aria-label="Loading"
        />
      ) : isSuccess ? (
        <CheckCircleOutline data-testid="success" />
      ) : (
        isError && (
          <Typography
            data-testid="error"
            variant="body1"
          >
            <strong>{errorText}</strong>
          </Typography>
        )
      )}
    </Box>
  )
}

LoadStateIndicator.propTypes = {
  isError: PropTypes.bool,
  errorText: PropTypes.string,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
}

export default LoadStateIndicator
